import React from "react";
import Logo from "components/Logo";
import classes from "./Auth/login.module.css";
import { TextField } from "@mui/material";
import { Link } from "react-router-dom";
function ForgotPassword() {
  return (
    <div className={classes.login}>
       <Logo />
      <form className={classes.root} noValidate autoComplete="off">
       
        <TextField
          className={classes.inputControl}
          id="filled-basic"
          label="Email"
          variant="filled"
        />
        <div className={classes.actions}>
          <Link className={classes.primaryButton} to="/login">
            Submit
          </Link>
        </div>
        <div className={classes.actions}>
          <Link className={classes.forgotPassword} to="/login">
            Go Back
          </Link>
        </div>
      </form>
    </div>
  );
}

export default ForgotPassword;
